<template>
  <section :id="$style.main_visual">
    <figure></figure>
    
    <emergency-contact
      v-observe-visibility="visibilityChanged_btn"
      :class="{[$style.emergency_contact]: true, ['animated fadeIn']: isVisible_btn}"
      :input_date="input_date"
    ></emergency-contact>

    <whats-new
      v-observe-visibility="visibilityChanged_btn"
      :class="{[$style.whats_new]: true, ['animated fadeIn']: isVisible_btn}"
      :input_date="input_date"
    ></whats-new>
    <ul :id="$style.main_button" :class="{['animated slideInUp']: isVisible_btn}">
      <router-link tag="li" :id="$style.about_nav" :to="{ name: 'info', hash: '#open_hour_area' }">
        <a>
          <span :class="$style.main_title">
            <b>営業時間</b>
            <small>Business hours</small>
          </span>
          <span :class="[$style.detail, $style.business_detail]">
            <b>
              <time>9:00</time> to
              <time>17:00</time>
            </b>
            <small>&ast;入館は16:50まで</small>
          </span>
        </a>
      </router-link>
      <router-link tag="li" :id="$style.about_nav" :to="{ name: 'info', hash: '#fee_area' }">
        <a>
          <span :class="$style.main_title">
            <b>入館料</b>
            <small>Entrance fee</small>
          </span>
          <span :class="[$style.detail, $style.entrance_detail]">
            <b>
              一般：
              <span>&yen; 400</span>
            </b>
            <small>&ast;お子様，団体，障害者割引がございます</small>
          </span>
        </a>
      </router-link>
      <router-link tag="li" :id="$style.about_nav" :to="{ name: 'info', hash: '#access_area' }">
        <a>
          <span :class="$style.main_title">
            <b>アクセス</b>
            <small>Access</small>
          </span>
          <span :class="[$style.detail, $style.access_detail]">
            <b>石川県能美市山口町タ58番地</b>
            <small>&ast;無料駐車場を完備しております</small>
          </span>
        </a>
      </router-link>
    </ul>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import WhatsNew from "@/components/molecules/WhatsNew.vue";
import EmergencyContact from "@/components/molecules/EmergencyContact.vue";
import { LookMe, DreamPost, CustomerVoice ,Saying} from "@/api";

export default Vue.extend({
  name: "MainHomeVisual",
  components: {
    WhatsNew,
    EmergencyContact
  },
  data() {
    return {
      isVisible_btn: Boolean,
      input_date: {
        lookme: "",
        dream: "",
        customer: "",
        saying: "",
      }
    };
  },
  mounted() {
    LookMe.getLookmeInputDate().then(({ input_date }) => {
      this.input_date.lookme = this.splitDate(input_date)[0];
    });
    DreamPost.getDreamInputDate().then(({ input_date }) => {
      this.input_date.dream = this.splitDate(input_date)[0];
    });
    CustomerVoice.getCustomerInputDate().then(({ input_date }) => {
      this.input_date.customer = this.splitDate(input_date)[0];
    });
    Saying.getNumberOfItems().then(({count}) => {
      this.input_date.saying = count;
    });
  },
  methods: {
    visibilityChanged_btn(isVisible) {
      this.isVisible_btn = isVisible;
    },
    splitDate(str) {
      const result = str.split("T");
      return result;
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  $font_color: #fff;
  $font_size: 14px;
  $background-color: #333333;

  #main_visual {
    height: 100vh;
    width: 100%;
    top: 0;
    position: relative;

    // メイン画像
    figure {
      background-image: url("../../../assets/top01.jpg");
      background-repeat: no-repeat;
      margin: 0;
      background-size: cover;
      height: 100vh;
      width: 100%;
      position: fixed;
      z-index: 0;
      background-position: -410px 0px;
    }

    // Whats New
    .whats_new {
      position: absolute;
      top: 100px;
      left: 0px;
    }

    // Emergency Contact
    .emergency_contact {
      position: absolute;
      top: 180px;
      left: 0px;
      right: 0px;
      margin: auto;
    }

    // メインボタン 共通設定
    #main_button {
      list-style-type: none;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      flex-wrap: wrap;
      bottom: 5px;
      width: 100%;
      padding: 0;

      li {
        background-color: rgba($background-color, 0.7);
        height: 75px;
        width: 286px;
        margin: 4px 0px;
        &::before {
          content: "";
          position: absolute;
          height: 52px;
          border-left: 3px solid $font_color;
          margin-top: 13px;
        }

        a {
          text-decoration: none;
          color: $font_color;
          font-size: $font_size;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;

          .main_title {
            width: 77px;
            // 縦に積む
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            // 中央寄せ
            justify-content: center;
            align-items: center;
            small {
              width: 85px;
              text-align: center;
            }
          }

          .detail {
            // 縦に積む
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            // 中央寄せ
            justify-content: center;
            align-items: center;

            small {
              font-size: 10px;
            }
          }
        }
      }
    }
  }

  .business_detail {
    padding-left: 30px;
    time {
      font-size: $font_size + 4;
    }
  }
  .entrance_detail {
    padding-left: 12px;
    b {
      font-size: $font_size + 2;
      span {
        font-size: $font_size + 4;
      }
    }
  }
  .access_detail {
    padding-left: 6px;
  }
}

@media only screen and (min-width: 1024px) {
  $font_color: #fff;
  $font_size: 14px;
  $background-color: #333333;

  #main_visual {
    height: 100vh;
    width: 100%;
    top: 0;
    position: relative;

    // メイン画像
    figure {
      background-image: url("../../../assets/top01.jpg");
      background-repeat: no-repeat;
      margin: 0;
      background-size: cover;
      height: 100vh;
      width: 100%;
      position: absolute;
    }

    // Whats New
    .whats_new {
      position: absolute;
      // top: 340px;
      right: 30px;
      bottom: 250px;
    }

    // Emergency Contact
    .emergency_contact {
      position: absolute;
      left: 30px;
      top: 130px;
    }

    // メインボタン 共通設定
    #main_button {
      list-style-type: none;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      bottom: 40px;
      width: 100%;
      padding: 0;

      li {
        background-color: rgba($background-color, 0.7);
        height: 90px;
        width: 310px;
        &::before {
          content: "";
          position: absolute;
          height: 67px;
          border-left: 3px solid $font_color;
          top: 13px;
        }
        &:hover {
          background-color: lighten(rgba($background-color, 0.7), 10%);
        }

        a {
          text-decoration: none;
          color: $font_color;
          font-size: $font_size;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;

          .main_title {
            width: 77px;
            // 縦に積む
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            // 中央寄せ
            justify-content: center;
            align-items: center;
            small {
              width: 80px;
              text-align: center;
            }
          }

          .detail {
            // 縦に積む
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            // 中央寄せ
            justify-content: center;
            align-items: center;

            small {
              font-size: 10px;
            }
          }
        }
      }
    }
  }

  .business_detail {
    padding-left: 20px;
    time {
      font-size: $font_size + 4;
    }
  }
  .entrance_detail {
    padding-left: 12px;
    b {
      font-size: $font_size + 2;
      span {
        font-size: $font_size + 4;
      }
    }
  }
  .access_detail {
    padding-left: 13px;
  }
}
</style>
